<template>
  <el-dialog
    :close-on-click-modal="false"
    title="设置部门"
    width="660px"
    custom-class="setDepart"
    :visible.sync="dialogSetDepartVisible"
    @close="cancelSetDepart"
  >
    <el-row class="contentBox">
      <el-col :span="12" class="left">
        <Search
          placeholder="搜索部门"
          @handleSearch="handleSearchDepart"
          ref="searchDepart"
        ></Search>
        <el-tree
          ref="departTree"
          :data="department"
          show-checkbox
          node-key="id"
          :default-expand-all="true"
          :check-strictly="true"
          :props="defaultProps"
          :filter-node-method="filterNode"
          @check="handleCheckChange"
        >
        </el-tree>
      </el-col>
      <el-col :span="12">
        <ul>
          <li v-for="item in selectedDepart" :key="item.id">
            <span>{{ item.name }}</span>
            <i class="icon icon-close" @click="removeSelectDepart(item)"></i>
          </li>
        </ul>
      </el-col>
    </el-row>
    <div class="tableTip">{{ mark }}</div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitSetDepart">确 定</el-button>
      <el-button @click="cancelSetDepart">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Search from "@/components/common/Search.vue"

export default {
  components: {
    Search
  },
  props: {
    selectAccount: {
      type: Array,
      default: () => []
    },
    department: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogSetDepartVisible: false,
      initSelectDepart: [],
      selectedDepart: [],
      defaultProps: {
        children: "subGroups",
        label: "name"
      },
      mark:
        "注：当选中的多个部门是上下级关系时，保存后账户部门信息仅显示最下级部门。"
    }
  },
  watch: {
    dialogSetDepartVisible(newValue) {
      if (newValue) {
        this.initSelectDepart = [...this.selectedDepart]
        this.initDepartSelect()
        this.initScrollbar()
      }
    },
    selectAccount(newValue) {
      // 思路：分是否多选两种情况
      // 1、如果是单选，则取该账户的部门信息
      // 2、否则，取所选账户部门的交集
      if (newValue.length === 0) {
        this.selectedDepart = []
      } else if (newValue.length === 1) {
        this.selectedDepart = [...newValue[0].department]
      } else {
        this.selectedDepart = this.getDuplId(newValue)
      }
    }
  },
  methods: {
    // 初始化滚动条位置
    initScrollbar() {
      this.$nextTick(() => {
        let scrollDom = document.querySelector(".el-dialog.setDepart .el-tree")
        if (scrollDom) {
          scrollDom.scrollTo(0, 0)
        }
      })
    },
    // 获取所选账户中共有的部门
    getDuplId(select) {
      // console.log(select)

      // 1、获取所有账户下所有的部门和id
      let allDepart = select.reduce((pre, cur) => {
        return pre.concat(cur.department)
      }, [])
      let allDepartId = allDepart.map(item => item.id)
      // 2、对所有部门id进行去重处理
      let allDepartIdDeDupl = [...new Set(allDepartId)]
      // 3、获取所有重复的id
      // let duplId = []
      allDepartIdDeDupl.forEach(item => {
        allDepartId.splice(
          allDepartId.findIndex(innerItem => innerItem === item),
          1
        )
      })
      // 对所有重复得id进行去重处理
      allDepartId = [...new Set(allDepartId)]
      // 去掉不是存在于每个账户中的部门
      allDepartId = allDepartId.filter(id => {
        return select.every(account => {
          return account.department.find(depart => depart.id === id)
        })
      })
      // 4、通过id查找部门
      return allDepartId.map(id => {
        let cur = allDepart.find(item => item.id === id)
        if (cur) {
          return {
            id: id,
            name: cur.name
          }
        }
      })
    },
    // 取消设置部门
    cancelSetDepart() {
      let _this = this
      this.dialogSetDepartVisible = false
      // 用延迟是为了解决，选中部门状态闪烁问题，在弹窗完全消失后，在进行状态的变更
      setTimeout(() => {
        _this.selectedDepart = [..._this.initSelectDepart]
        _this.$refs.departTree.setCheckedNodes(_this.selectedDepart)
      }, 500)
    },
    // 搜索部门
    handleSearchDepart(value) {
      this.$refs.departTree.filter(value)
    },
    // 部门过滤
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 部门树选中状态变化时
    handleCheckChange() {
      this.selectedDepart = [...this.$refs.departTree.getCheckedNodes()]
    },
    // 从选中列表中移除部门
    removeSelectDepart({ id }) {
      let index = this.selectedDepart.findIndex(item => item.id === id)
      this.selectedDepart.splice(index, 1)
      this.$refs.departTree.setCheckedNodes(this.selectedDepart)
    },
    // 确认设置部门
    submitSetDepart() {
      // 找到要移除的部门
      let remDepartIds = this.initSelectDepart
        .filter(
          item =>
            !this.selectedDepart.some(innerItem => innerItem.id === item.id)
        )
        .map(item => item.id)
      // 找到要添加的部门
      let addDepartIds = this.selectedDepart
        .filter(
          item =>
            !this.initSelectDepart.some(innerItem => innerItem.id === item.id)
        )
        .map(item => item.id)
      // 当前选中的部门为空，且移除后任意账户部门为空，则不能提交
      let dontHaveDepartAccount = this.selectAccount.find(
        item => item.department.length === remDepartIds.length
      )
      if (
        this.selectedDepart.length === 0 &&
        dontHaveDepartAccount !== undefined
      ) {
        this.$message.error({
          message: "至少设置一个所在部门"
        })
      } else if (remDepartIds.length || addDepartIds.length) {
        // 如果满足调接口条件后，通知父组件可以调保存部门的接口了
        this.$emit("setDepartment", { remDepartIds, addDepartIds })
      } else {
        this.dialogSetDepartVisible = false
      }
    },
    initDepartSelect() {
      this.$nextTick(() => {
        this.$refs.searchDepart.keywords = ""
        this.handleSearchDepart("")
        this.$refs.departTree.setCheckedNodes(this.initSelectDepart)
      })
    }
  }
}
</script>

<style lang="scss">
.el-dialog {
  &.setDepart {
    .el-dialog__body {
      height: 360px;
      padding: 20px 50px 0;
      .el-row.contentBox {
        height: 320px;
        overflow: hidden;
        .el-col {
          height: inherit;
          padding-right: 10px;
          &.left {
            border-right: 1px solid #ececec;
          }
          .searchBox {
            width: 100%;
            margin-bottom: 10px;
          }
          .el-tree {
            background-color: #ffffff;
            height: calc(100% - 40px);
            overflow: auto;
            & > .el-tree-node {
              min-width: 100%;
              width: fit-content;
            }
            &-node__content {
              border-bottom: none;
            }
          }
          ul {
            li {
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding-left: 30px;
              .icon {
                cursor: pointer;
              }
            }
          }
        }
      }
    }
    .tableTip {
      font-size: 12px;
      margin-top: 4px;
    }
  }
}
</style>
